/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the CodeTableType
 *
 * @class CodeTableType
 */
class CodeTableType {
  /**
   * Creates an instance of CodeTableType.
   * @param {*} json
   * @memberof CodeTableType
   */
  constructor(json = null) {
    if (json) {
      // string
      this.tableName = json.tableName;

      // string
      this.value = json.value;

      // string
      this.description = json.description;

      // string
      this.parentCodeTable = json.parentCodeTable;
    }
  }
}

/**
 * Models the UAApplicationProgramStatus
 *
 * @class UAApplicationProgramStatus
 */
class UAApplicationProgramStatus {
  /**
   * Creates an instance of UAApplicationProgramStatus.
   * @param {*} json
   * @memberof UAApplicationProgramStatus
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.hasPendingWithdrawalRequest = json.hasPendingWithdrawalRequest;

      // object - CodeTableType
      if (json.status) {
        this.status = new CodeTableType(json.status);
      }

      // string
      this.withdrawalRequestStatusMessage = json.withdrawalRequestStatusMessage;

      // boolean
      this.canBeWithdrawn = json.canBeWithdrawn;
    }
  }
}

/**
 * Models the UASubmittedApplicationProgram
 *
 * @class UASubmittedApplicationProgram
 */
class UASubmittedApplicationProgram {
  /**
   * Creates an instance of UASubmittedApplicationProgram.
   * @param {*} json
   * @memberof UASubmittedApplicationProgram
   */
  constructor(json = null) {
    if (json) {
      // string
      this.name = json.name;

      // string
      this.application_program_id = json.application_program_id;

      // object - UAApplicationProgramStatus
      if (json.programStatusDetails) {
        this.programStatusDetails = new UAApplicationProgramStatus(json.programStatusDetails);
      }
    }
  }
}

/**
 * Models the UASubmittedApplication
 *
 * @class UASubmittedApplication
 */
class UASubmittedApplication {
  /**
   * Creates an instance of UASubmittedApplication.
   * @param {*} json
   * @memberof UASubmittedApplication
   */
  constructor(json = null) {
    if (json) {
      // string
      this.application_id = json.application_id;

      // string
      this.submittedOn = json.submittedOn;

      // string
      this.name = json.name;

      // object - CodeTableType
      if (json.status) {
        this.status = new CodeTableType(json.status);
      }

      // array - UASubmittedApplicationProgram
      if (json.applicationPrograms) {
        this.applicationPrograms = json.applicationPrograms.map(
          object => new UASubmittedApplicationProgram(object)
        );
      } else if (json.constructor === Array) {
        this.applicationPrograms = json.map(object => new UASubmittedApplicationProgram(object));
      }
    }
  }
}

/**
 * Models the UASubmittedApplicationList
 *
 * @class UASubmittedApplicationList
 */
class UASubmittedApplicationList {
  /**
   * Creates an instance of UASubmittedApplicationList.
   * @param {*} json
   * @memberof UASubmittedApplicationList
   */
  constructor(json = null) {
    if (json) {
      // array - UASubmittedApplication
      if (json.data) {
        this.data = json.data.map(object => new UASubmittedApplication(object));
      } else if (json.constructor === Array) {
        this.data = json.map(object => new UASubmittedApplication(object));
      }
    }
  }
}

export default {
  CodeTableType,

  UAApplicationProgramStatus,

  UASubmittedApplicationProgram,

  UASubmittedApplication,

  UASubmittedApplicationList,
};
